import React, { useMemo } from 'react';
import { FluentProvider } from '@fluentui/react-components';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { appTheme } from '@/theme/fluentTheme';
import { UserPrefsProvider } from '@/context/UserPrefsContext';


const App: React.FC = () => {
const theme = useMemo(() => appTheme, []);
return (
<FluentProvider theme={theme} style={{ minHeight: '100dvh' }}>
<UserPrefsProvider>
<RouterProvider router={router} />
</UserPrefsProvider>
</FluentProvider>
);
};


export default App;
